import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { fetchVideos } from '../utils/api'

import VideoListing from '../components/VideoListing/VideoListing'

function SearchResults () {
  const { query } = useParams()

  const [videos, setVideos] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    /*fetchVideosByTag(query).then(results => {
      setVideos(results)
      setIsLoading(false)
    })*/

    fetchVideos().then(results => {
      const matches = results.items.filter(item => {
        if (item.snippet.title.toLowerCase().includes(query)) {
          return item
        }

        let matchesTag = false
        item.tags.forEach(tag => {
          if (tag.toLowerCase().includes(query)) {
            matchesTag = true
          }
        })

        if (matchesTag) return item
      })

      setVideos(matches)
    })

    setIsLoading(false)

  }, [query])

  return (
    <>
      {videos.length !== 0 ? (
        <VideoListing videos={videos} setVideos={setVideos}/>
      ) : (
        <div style={{
          minHeight: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <h2 style={{ fontSize: '1.85rem' }}>
            {isLoading ? 'Loading...' : `No results were found for "${query}"`}
          </h2>
        </div>
      )}
    </>
  )
}

export default SearchResults